<div class="page-wrapper back_col">
<header>
  <nav class="navbar navbar-expand-lg navbar-light Header">
    <h5 class="my-0 resp-mar font-weight-normal">
      <i class="fa fa-long-arrow-left cursor-point"
         data-toggle="tooltip" title="Acceuil"
         (click)="onRedirectHome()"></i></h5>
    <div>
      <img class="ekaidi_img" src="assets/images/ekaidi_max.png">
    </div>
    <button class="navbar-toggler" type="button" (click)="show=!show">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse text-center" [ngClass]="{'show' : show}">
      <ul class="nav navbar-nav ml-auto">
        <div class="nav-link my-2 my-md-0 mr-md-3">
          <button class="btn btn-primary mb-1 respon" (click)="onRedirectlogin()">
            <i class="fa fa-lock mr-2" aria-hidden="true"></i>
            <span class="button-font" translate>haveacc</span>
          </button>
        </div>
      </ul>
    </div>
  </nav>
</header>
<main class="content container">
<p>
  <span class="font-col" (click)="onRedirectHome()" translate>bred_appointment</span>
  <span class="_font-col text-muted" translate>bred_track</span>
</p>
<div class="container mt-5">
  <div class="card shadow-sm p-4">
    <h4 class="mb-3">
      <i class="bi bi-file-earmark-text me-2"></i><span translate>pass_track</span>
    </h4>
    <form [formGroup]="passportForm" (ngSubmit)="onSubmit()">
      <div class="row g-3">
        <div class="col-md-3">
          <label for="nom" class="form-label"><span translate>nom_nec</span> <span class="text-danger"> *</span></label>
          <input
            type="text"
            class="form-control"
            id="nom"
            formControlName="nom"
            placeholder="CONDE"
          />
          <div *ngIf="passportForm.get('nom')?.invalid && passportForm.get('nom')?.touched" class="text-danger">
            <span class="error_class" translate>nom_req</span>
          </div>
        </div>
        <div class="col-md-3">
          <label for="dateNaissance" class="form-label"><span translate>naiss</span> <span class="text-danger"> *</span></label>
          <input
            type="date"
            class="form-control"
            id="dateNaissance"
            formControlName="dateNaissance"
          />
          <div *ngIf="passportForm.get('dateNaissance')?.invalid && passportForm.get('dateNaissance')?.touched"
               class="text-danger">
            <span class="error_class" translate>naiss_req</span>
          </div>
        </div>
        <div class="col-md-3">
          <label for="numCarteConsulaire" class="form-label"><span translate>cart_con</span> <span class="text-danger"> *</span></label>
          <input
            type="text"
            class="form-control"
            id="numCarteConsulaire"
            formControlName="numCarteConsulaire"
            placeholder="{{ 'cid_plh' | translate}}"
          />
          <div
            *ngIf="passportForm.get('numCarteConsulaire')?.invalid && passportForm.get('numCarteConsulaire')?.touched"
            class="text-danger">
            <span class="error_class" translate>cidNumber_req</span>
          </div>
        </div>
        <div class="col-md-3">
          <label for="numPersonnel" class="form-label"><span translate>num_recep</span> <span class="text-danger"> *</span></label>
          <input
            type="text"
            class="form-control"
            id="numPersonnel"
            formControlName="numPersonnel"
            placeholder="1X7908RG0995678"
          />
          <div *ngIf="passportForm.get('numPersonnel')?.invalid && passportForm.get('numPersonnel')?.touched"
               class="text-danger" translate>
            <span class="error_class" translate>error_recep</span>
          </div>
        </div>
      </div>

      <button [disabled]="passportForm.invalid || !spinner" type="submit" class="btn btn-primary mt-4" translate>
        search
        <span [hidden]="spinner" class="spinner-border spinner-border-sm mr-2" role="status"
              aria-hidden="true"></span>
      </button>
    </form>
  </div>

  <!-- Section de statut -->
  <div class="container mt-5" *ngIf="trackResp?.data != null">
    <div class="p-4 bg-light rounded">
      <h5 *ngIf="trackResp?.data?.available && trackResp?.data?.withdrawn == false" class="text-center text-primary mb-4" translate>
        message_1
      </h5>
      <h5 *ngIf="!trackResp?.data?.withdrawn && !trackResp?.data?.available" class="text-center text-primary mb-4" translate>
        message_2
      </h5>
      <h5 *ngIf="trackResp?.data?.withdrawn" class="text-center text-primary mb-4" translate>
        message_3
      </h5>

      <div class="status-progress d-flex justify-content-between align-items-center flex-wrap">

        <div class="status-step completed">
          <span class="status-circle"></span>
          <span class="status-text" translate>step_1</span>
        </div>

        <span class="status-arrow">➜</span>

        <div class="status-step completed">
          <span class="status-circle"></span>
          <span class="status-text" translate>step_2</span>
        </div>

        <span class="status-arrow">➜</span>

        <div class="status-step" [ngClass]="{
                 'in-progress': !trackResp.data.available && !trackResp.data.withdrawn,
                 'completed': trackResp.data.available || trackResp.data.withdrawn}">
          <span class="status-circle"></span>
          <span class="status-text" translate>step_3</span>
        </div>

        <span class="status-arrow">➜</span>

        <div class="status-step" [ngClass]="{
                 'pending': !trackResp.data.available && !trackResp.data.withdrawn,
                 'in-progress': trackResp.data.available && !trackResp.data.withdrawn,
                 'completed': trackResp.data.withdrawn && trackResp.data.available || trackResp.data.withdrawn && !trackResp.data.available}">
          <span class="status-circle"></span>
          <span *ngIf="!trackResp.data.withdrawn" class="status-text" translate>step_4</span>
          <span *ngIf="trackResp.data.withdrawn" class="status-text" translate>step_5</span>
        </div>
      </div>
    </div>
  </div>
</div>
</main>

<footer class="_footer" style="background-color: #2c292f">
  <div class="container">
    <div class="row justify-content-center custom-foo">
      <div class="col-md-4 text-white text-center">
        <div class="mt-4">
          <p class="text-light">
            <img src="assets/images/logo.png"
                 class="mr-1 mb-1"
                 style="width: 43px; height: 23px"/><span class="button-font">&copy;2020 A2A Expertise</span>
          </p>
        </div>
      </div>

      <div class="col-md-4 text-white text-center">
        <div class="mt-4">
          <div>
            <p><i class="fa fa-envelope mt-1 mr-2"></i><a
              href="mailto:consulats@ambaguinee.org" style="color: #1587bd">consulats@ambaguinee.org</a></p>
          </div>
        </div>
      </div>

      <div class="col-md-4 text-white text-center">
        <div class="mt-3 pt-1">
          <a href="https://www.facebook.com/A2A-Expertise-2065223603792416/"><i
            class="fa fa-facebook fa-2x text-primary mx-3"></i></a>
          <a href="https://www.linkedin.com/company/a2a-expertise"><i class="fa fa-linkedin fa-2x text-danger mx-3"></i></a>
          <a href="https://twitter.com/"><i class="fa fa-twitter fa-2x text-info mx-3"></i></a>
          <a href="https://www.youtube.com/watch?v=l21QDxgQjSc"><i class="fa fa-youtube fa-2x text-danger mx-3"></i></a>
        </div>
      </div>
    </div>
  </div>
</footer>
<div bsModal #errorModal="bs-modal" class="modal fade" tabindex="-1" [config]="{backdrop: 'static'}"
     role="dialog" aria-labelledby="dialog-child-name">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <span class="text-danger" translate>error_desc</span>
      </div>
      <div class="modal-body text-center">
        <span> {{ error | translate }}</span>
      </div>
      <div class="modal-footer">
        <div class="row">
          <div class="ml-auto mr-2">
            <button class="btn btn-primary btn-sm btn-block"
                    (click)="hideModal()" translate>
              close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
